export function getImageUrl(path?: string): string {
	const base = process.env.NEXT_PUBLIC_API_URL;
	if (!base) {
		throw new Error("NEXT_PUBLIC_API_URL is not defined");
	}
	return path ? `${base}${path}` : "/placeholder.png";
}
